import { render, staticRenderFns } from "./ExternalDownloadTickets.vue?vue&type=template&id=63871eb9&scoped=true"
import script from "./ExternalDownloadTickets.vue?vue&type=script&lang=js"
export * from "./ExternalDownloadTickets.vue?vue&type=script&lang=js"
import style0 from "./ExternalDownloadTickets.vue?vue&type=style&index=0&id=63871eb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63871eb9",
  null
  
)

export default component.exports